module.exports = __webpack_public_path__ + "static/media/tick.e8a6f255.svg";